import IGoogleViewPricing from "../contracts/IGoogleViewPricing";
import PricingHandler from "../contracts/PricingHandler";

/**
 * Assigns price to p1 times lowest quantity multiplier except in the case of quantity discounts.
 *
 * When Quantity Discounts are available price will be assigned to the lowest quantity discount price times the lowest quantity multiplier.
 *
 * @remarks This handler MUST be last in the chain of handlers when MAP or quantity discounts are possible,
 * as it depends on MAP and quantity discount pricing.
 * @param input
 * @param resolvedPricing
 */
const googleViewHandler: PricingHandler<IGoogleViewPricing> = (
  input,
  resolvedPricing,
) => {
  if (!input.isGoogleView || input.user.isLoggedIn) return resolvedPricing;

  /*
    depending on map style, a user may be qualified for p4, but we don't want to show it in google view so we remove
    it to avoid the implication that the user is seeing p4 when it is truly p1 or lowest quantity discount price
  */
  delete resolvedPricing.metadata?.belowMapQualified;

  const quantityMultiplier = Math.max(input.minimumQuantity, input.mustBuy);

  const pricing = {
    ...resolvedPricing,
    metadata: {
      ...resolvedPricing.metadata,
      googleView: true,
    },
    price: input.p1 * quantityMultiplier,
  };

  if (resolvedPricing.metadata?.mapStyle) return pricing;
  if (!resolvedPricing.quantityDiscounts?.length) return pricing;

  // when quantity discounts exist and there is a lower price than p1, show lowest quantity discount price
  const lowestQuantityDiscount = resolvedPricing.quantityDiscounts[0];
  if (
    lowestQuantityDiscount &&
    !lowestQuantityDiscount.lot &&
    input.p1 > lowestQuantityDiscount.price
  )
    return {
      ...pricing,
      price: lowestQuantityDiscount.price * quantityMultiplier,
    };

  return pricing;
};

export default googleViewHandler;
